/**
 * 선물상자 인벤토리 조회 훅 — 최적화 버전
 * 🎯 [Cost Optimization] Cloud Function 호출 제거, AppContext의 실시간 데이터 사용
 */
import { useMemo, useCallback } from 'react';
import { useAppContext } from '../../../contexts/AppContext';
import { getKSTTodayStr, getNextKSTMidnightISO } from '../../../utils/dateUtils';

export function useGiftBoxInventory(userId, environment, options = {}) {
  const { pointSpotInventory, setPointSpotInventory } = useAppContext();

  // 🎯 [Logic] 오늘 날짜 확인 (서버와 동일하게 KST 기준). today 의존으로 자정(KST) 전환 시 재계산
  const today = getKSTTodayStr();
  const inventory = useMemo(() => {
    if (pointSpotInventory && pointSpotInventory.date === today) {
      return pointSpotInventory;
    }
    // 날짜가 다르거나 데이터가 없으면 0으로 초기화된 객체 반환
    return { date: today, normal: 0, landmark: 0 };
  }, [pointSpotInventory, today]);

  // 🎯 [Logic] 다음 날 00:00 KST 계산 (UTC 기반 정확한 계산)
  const expiresAt = useMemo(() => {
    return getNextKSTMidnightISO();
  }, []);

  // API 호출이 없으므로 loading은 데이터가 아직 없을 때만 true
  const loading = pointSpotInventory === undefined;
  const error = null;

  // refresh는 이제 로컬 상태를 재검토하거나, 필요 시 빈 함수로 유지 (onSnapshot이 자동 관리)
  const refresh = useCallback(() => {
    console.log('[useGiftBoxInventory] Realtime sync active, manual refresh skipped');
  }, []);

  return { inventory, expiresAt, loading, error, refresh };
}
